<page-content [fullPageWidth]="false">
    <header-elitment header [hasSideMenu]="true"></header-elitment>
    <side-menu left-menu>
        <athlete-side-menu></athlete-side-menu>
    </side-menu>
    <module-content title="{{ pageTitle|translate }}">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center" >
            <div>
                <app-stats-range-selector
                        [dateFrom]="dateFrom"
                        [dateTo]="dateTo"
                        (dateFromEvent)="handleDateFromEvent($event)"
                        (dateToEvent)="handleDateToEvent($event)">
                </app-stats-range-selector>
            </div>
            <div>
                <button mat-raised-button color="primary" [matMenuTriggerFor]="menu">{{ 'StatsChange'|translate }}</button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="handleMenuChange('accents-hours')">{{ 'StatsAccentsHours' | translate }}</button>
                    <button mat-menu-item (click)="handleMenuChange('exercises')">{{ 'StatsExercises' | translate }}</button>
                    <button mat-menu-item (click)="handleMenuChange('accents')">{{ 'StatsAccents' | translate }}</button>
                </mat-menu>
            </div>
        </div>

        <ng-template #statsComponentRef></ng-template>
    </module-content>
</page-content>
